function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M13.5 3.9375V14.0625H4.5V3.9375H13.5Z",
  fill: "#FDB913"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.375 1.125H5.625C5.17745 1.125 4.74822 1.30279 4.43176 1.61926C4.11529 1.93572 3.9375 2.36495 3.9375 2.8125V15.1875C3.9375 15.6351 4.11529 16.0643 4.43176 16.3807C4.74822 16.6972 5.17745 16.875 5.625 16.875H12.375C12.8226 16.875 13.2518 16.6972 13.5682 16.3807C13.8847 16.0643 14.0625 15.6351 14.0625 15.1875V2.8125C14.0625 2.36495 13.8847 1.93572 13.5682 1.61926C13.2518 1.30279 12.8226 1.125 12.375 1.125ZM5.0625 4.5H12.9375V13.5H5.0625V4.5ZM5.625 2.25H12.375C12.5242 2.25 12.6673 2.30926 12.7727 2.41475C12.8782 2.52024 12.9375 2.66332 12.9375 2.8125V3.375H5.0625V2.8125C5.0625 2.66332 5.12176 2.52024 5.22725 2.41475C5.33274 2.30926 5.47582 2.25 5.625 2.25ZM12.375 15.75H5.625C5.47582 15.75 5.33274 15.6907 5.22725 15.5852C5.12176 15.4798 5.0625 15.3367 5.0625 15.1875V14.625H12.9375V15.1875C12.9375 15.3367 12.8782 15.4798 12.7727 15.5852C12.6673 15.6907 12.5242 15.75 12.375 15.75Z",
  fill: "#052D6B"
});

var SvgMobileDevice = function SvgMobileDevice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobileDevice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mobileDevice.09babee4.svg";
export { ForwardRef as ReactComponent };